import { usePresentationContext } from '@mentimeter/question-modules-contexts';
import { TitleSection } from '@mentimeter/question-modules-shared';
import { Box } from '@mentimeter/ragnar-ui/box';
import { isEmptyObject } from '@tiptap/core';
import { useTranslations } from 'next-intl';
import { getNinePointLayoutProperties } from '../../shared/utils/getNinePointLayoutProperties';
import { VideoDataHandler } from './components/VideoDataHandler';

export function VideoPresentation() {
  const { useQuestion, useConfig } = usePresentationContext();
  const t = useTranslations('presenting');

  const {
    layout,
    question,
    title_meta,
    question_video_embed_url,
    question_styled,
  } = useQuestion();
  const { readonly, mode } = useConfig();
  const { InteractiveCanvasComponents } = usePresentationContext();

  const { textAlign, justifyContent, alignItems } =
    getNinePointLayoutProperties(layout);

  // When we are in Editor always show TitleSection. If we are in a presentation we only show if there is a styled/non-styled title. Otherwise hide since we don't want the container taking up empty space.
  const showTitleSection = Boolean(
    InteractiveCanvasComponents?.CanvasTitleArea ||
      !isEmptyObject(question_styled) ||
      question,
  );
  return (
    <Box
      width="100%"
      height="100%"
      data-testid="video-container"
      justifyContent={justifyContent}
      alignItems={alignItems}
    >
      <VideoDataHandler
        videoUrl={question_video_embed_url}
        shouldShowPreview={mode === 'screenshot'}
        readonly={readonly}
      />
      {showTitleSection ? (
        <TitleSection
          enablePlaceholderAlignment
          alignItems={alignItems}
          textAlign={textAlign}
          title={question}
          styledTitle={question_styled}
          label={title_meta}
          fontSizeOffset={layout?.font_size_offset}
          mb="space0"
          placeholder={t('video_slide_caption_placeholder')}
          showTextSizeDropdown={false}
        />
      ) : null}
    </Box>
  );
}
